import { DossierDetailType } from "../../../../types";
import { Grid } from "@mui/material";
import DossierToAssignCard from "./DossierToAssignCard";

type DossiersToAssignCards = {
    dossiers: DossierDetailType[];
    handleDossiersToAssignSelect: Function;
};

export default function DossiersToAssignCardList({
    dossiers,
    handleDossiersToAssignSelect,
}: DossiersToAssignCards) {
    return (
        <Grid container spacing={2}>
            {dossiers.map((d: DossierDetailType) => (
                <Grid item xs={12} sm={6} key={d.id}>
                    <DossierToAssignCard
                        dossierDetail={d}
                        onDossierSelect={handleDossiersToAssignSelect}
                    />
                </Grid>
            ))}
        </Grid>
    );
}
